import {
  FlyerDetailPagePreview,
  FlyerDetailPagePreviewPosition,
} from "./flyer-detail-page-preview.interface";
import { IPermissions } from "../../../../../../../../types/user/permissions/ipermissions/ipermissions.interface";
import { calculatePermissions } from "../../../../../../../../types/user/permissions/ipermissions/ipermissions.functions";
import { IUser } from "../../../../../../../../types/user/iuser.interface";
import { IPermissionsContext } from "../../../../../../../../types/user/permissions/ipermissions-context/ipermissions-context.interface";
import { Nullable } from "../../../../../../../../types/common";

export const findPagePositionPreviewById = (
  pagePositionId: number,
  pagePreview: FlyerDetailPagePreview
): FlyerDetailPagePreviewPosition | undefined =>
  pagePreview.positions.find((position) => position.id === pagePositionId);

export function createPermissionsFromFlyerPagePreview(
  user: IUser,
  preview: FlyerDetailPagePreview
): IPermissions {
  return calculatePermissions(createPermissionsContextFromFlyerDetailPagePreview(user, preview));
}

export function hasPageDetails(pagePreview: Nullable<FlyerDetailPagePreview>): boolean {
  if (!pagePreview) {
    return false;
  }
  return Boolean(pagePreview.notes || pagePreview.theme);
}

export function createPermissionsContextFromFlyerDetailPagePreview(
  user: IUser,
  preview: FlyerDetailPagePreview
): IPermissionsContext {
  return {
    userId: user.id,
    userGroups: user.groups,
    pageType: "flyers",
    briefOwnerId: preview.owner.id,
    pageOwnerId: preview.owner.id,
    executionOwnerId: null,
    pageStatus: preview.status,
    merchOwners: [],
  };
}
